<template>
<div>
  <h1 class="title">{{ $t('page.userTop') }}</h1>
  <p v-if="isUserAuth">{{ $t('msg.signInGreeting', { name: userDispName }) }}</p>
  <!--
  <p v-if="isUserAuth">
    <router-link v-if="isUserAuth" to="/user/answers" class="navbar-item">{{ $t('term.answers') }}</router-link>
  </p>
  -->
</div>
</template>

<script>

export default{
  data(){
    return {
    }
  },

  computed: {
    //userName () {
    //  const defName = this.$t('term.guestUser')
    //  if (this.checkEmpty(this.$store.state.auth.user)) return defName
    //  if (this.checkEmpty(this.$store.state.auth.user.name)) return defName
    //  return this.$store.state.auth.user.name
    //},
  },

  created() {
  },

  methods: {
  },
}
</script>
